import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { apiCall } from '../config/api';
import '../styles/invalid-licenses-bar.css';

function formatAnimalNames(names: string[]): string {
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} e ${names[1]}`;
  return `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`;
}

function getAlertMessage(animals: string[]): React.ReactNode {
  if (animals.length === 1) {
    return <>Licença inválida: <strong>{animals[0]}</strong></>;
  }
  if (animals.length <= 4) {
    return <>Licenças inválidas: <strong>{formatAnimalNames(animals)}</strong></>;
  }
  return <>Licenças inválidas: <strong>{animals.length} cães</strong></>;
}

const InvalidLicensesAlertBar: React.FC = () => {
  const { user } = useAuth();
  const [animals, setAnimals] = useState<string[]>([]);

  useEffect(() => {
    if (!user || user.role === 'guest') {
      setAnimals([]);
      return;
    }

    const load = async () => {
      try {
        const res = await apiCall('/licencas/invalid-active-animals', { method: 'GET' });
        setAnimals(res.animals || []);
      } catch {
        setAnimals([]);
      }
    };

    load();
  }, [user]);

  if (animals.length === 0) {
    return null;
  }

  return (
    <div
      className="invalid-licenses-bar"
      role="alert"
      title={animals.length > 4 ? animals.join(', ') : undefined}
    >
      <div className="container invalid-licenses-bar-inner">
        <i className="fas fa-exclamation-triangle invalid-licenses-bar-icon" aria-hidden="true"></i>
        <span className="invalid-licenses-bar-text">{getAlertMessage(animals)}</span>
        <span className="invalid-licenses-bar-sep" aria-hidden="true">·</span>
        <Link to="/licencas" className="invalid-licenses-bar-link">
          Ver
        </Link>
      </div>
    </div>
  );
};

export default InvalidLicensesAlertBar;
